const listgroupmsg = (state = [], action) => {
  switch (action.type) {
    case 'LISTGROUPMSG':
    return {
        type: "LISTGROUPMSG",
        groups: action.listgroupmsg
      }
    default:
      return state
  }
}

export default listgroupmsg